<template>
  <a-layout class="vb__layout">
    <a-layout-content>
      <div
        :class="{
          [$style.container]: true,
          vb__layout__squaredBorders: false,
          vb__layout__cardsShadow: true,
          vb__layout__borderless: false,
          [$style.white]: false,
          [$style.gray]: true,
        }"
        :style="{
          backgroundImage: 'url(resources/images/comercio.png)',
          backgroundSize: '100%',
        }"
      >
        <div
          :class="{
            [$style.topbar]: true,
            [$style.topbarGray]: false,
          }"
        >
          <div :class="$style.logoContainer">
              <a href="javascript: void(0);">
                <img src="resources/images/logo.png" />
              </a>
          </div>
        </div>
        <div class="mb-3">
          <router-view>
          </router-view>
        </div>
        <div class="mt-auto pb-5 pt-5">
          <div class="text-center">
            <b>CCEAD © {{ new Date().getFullYear() }}</b>
          </div>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
export default {
  name: 'AuthLayout',
}
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>

